import type { ComponentProps } from 'react';

import { cn } from '../cn';
import { ButtonPropsSizeType } from '../common.type';

type InputTitleProps = ComponentProps<'div'> & {
  size?: ButtonPropsSizeType;
  error?: string;
};
export default function InputTitle({ className, children, error, size, ...props }: InputTitleProps) {
  return (
    <div
      className={cn(
        'flex justify-between gap-1 font-semibold text-slate-600 dark:text-slate-100',
        {
          'px-2 text-sm': size === 'base' || size == null,
          'px-1.5 text-xs': size === 'sm',
          'px-1 text-2xs': size === 'xs',
        },
        { 'text-fair-pink-600': error },
        className,
      )}
      {...props}>
      {children}
      <span className="text-end">{error}</span>
    </div>
  );
}
